<div class="dogadjanja-page">

    <div class="dogadjanja-page__container">
        <dogadjanja-tablica *ngIf="dogadjanja" [dogadjanja]="dogadjanja"></dogadjanja-tablica>
    </div>

</div>